// extracted by mini-css-extract-plugin
module.exports = {"buttonIgnore":"styles_buttonIgnore__TrNBH","buttonComplete":"styles_buttonComplete__1K1JJ","text":"styles_text__9Y9Qn"};